import React from 'react'
import styled from 'styled-components'


const ProductLocationModal = () => {
  return (
    <MainWrapper>
      asd
    </MainWrapper>
  )
}


const MainWrapper = styled.div`
  width: 90vw;
  height: 80vh;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  overflow-y: auto;
  padding: 0 0.2em;
  &::-webkit-scrollbar {
    width: 0;
  }
`
export default ProductLocationModal